module.exports = __webpack_public_path__ + "img/TWC-front.4ef63e65.jpg";